import template from './bank-account-field-errors.html';

export default angular
  .module('app.holding.dashboard.bank-accounts')
  .directive('holdingBankAccountFieldErrors', holdingBankAccountFieldErrors)
  .name;

function holdingBankAccountFieldErrors() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      field: '=',
      name: '@',
      validation: '=?',
    },
    template,
  };
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bank-accounts/directives/bank-account-field-errors/bank-account-field-errors.js